import { createReducer, on } from '@ngrx/store';
import { Video } from '../../core/models/video.model';
import * as VideosActions from './videos.actions';

export interface VideoProgress {
  videoId: string;
  currentTime: number;
  duration: number;
  percentage: number;
}

export interface VideosState {
  byLeader: Record<string, Video[]>;
  continueWatching: Video[];
  progress: Record<string, VideoProgress>;
  isLoading: boolean;
  error: string | null;
}

export const initialVideosState: VideosState = {
  byLeader: {},
  continueWatching: [],
  progress: {},
  isLoading: false,
  error: null
};

export const videosReducer = createReducer(
  initialVideosState,

  on(VideosActions.loadVideosByLeader, state => ({ ...state, isLoading: true })),

  on(VideosActions.loadVideosByLeaderSuccess, (state, { leaderId, videos }) => ({
    ...state,
    byLeader: { ...state.byLeader, [leaderId]: videos },
    isLoading: false,
    error: null
  })),

  on(VideosActions.loadVideosByLeaderFailure, (state, { error }) => ({
    ...state, isLoading: false, error
  })),

  on(VideosActions.loadContinueWatchingSuccess, (state, { videos }) => ({
    ...state, continueWatching: videos
  })),

  on(VideosActions.updateVideoProgressSuccess, (state, { videoId, currentTime }) => {
    const existing = state.progress[videoId];
    if (!existing) return state;
    const percentage = existing.duration > 0 ? (currentTime / existing.duration) * 100 : 0;
    return {
      ...state,
      progress: {
        ...state.progress,
        [videoId]: { ...existing, currentTime, percentage }
      }
    };
  }),

  on(VideosActions.removeFromContinueWatching, (state, { videoId }) => ({
    ...state,
    continueWatching: state.continueWatching.filter(v => v.id !== videoId)
  }))
);
